import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import KycManuallyInReviewPage from './KycManuallyInReviewPage';

const KycManuallyInReviewRoute: FuseRouteItemType = {
  path: '',
  element: <KycManuallyInReviewPage />,
  auth: AUTH_ROLES.parent, // []
};

export default KycManuallyInReviewRoute;
